'use strict';

var React = require('react')

function isEmpty(ob){
  for(var i in ob)
  { return false;}
  return true;
}

var ErrorWrapper = React.createClass({
  getInitialState: function() {
    return {
      identifier: "",
      validationState: ""
    }
  },
  getDefaultProps: function() {
    return {
      errorlist: {},
      identifier: ""
    };
  },
  componentWillReceiveProps: function(newProps) {
    this.setState({identifier: newProps.identifier});
    if (isEmpty(newProps.errorlist)) {
      this.setState({validationState: ""});
    }
    else if(this.state.identifier in newProps.errorlist){
      this.setState({validationState: "has-error"});
    }
    else
      this.setState({validationState: ""});
    this.setState({identifier: newProps.identifier});
  },

  render: function () {
    return (
      <div className={this.state.validationState} id={this.state.identifier+"-container"}>
    {this.props.children}
    </div>
    );
  }
});

module.exports = ErrorWrapper



// WEBPACK FOOTER //
// ./js/errorWrapper.js